import z from 'zod'
import { decimalSchema } from '../../utils/schema'

/** Backpack の `Deposit` レスポンススキーマ */
export const depositSchema = z.object({
  /** 入金 ID */
  id: z.number(),
  /** 入金先アドレス (Backpack 側) */
  toAddress: z.string().nullish(),
  /** 送金元アドレス */
  fromAddress: z.string().nullish(),
  /** 入金元 (チェーンまたは payment processor) */
  source: z.string(),
  /** 入金ステータス */
  status: z.string(),
  /** ブロックチェーンのトランザクションハッシュ */
  transactionHash: z.string().nullish(),
  /** 入金アセットのシンボル */
  symbol: z.string(),
  /** 入金数量 */
  quantity: decimalSchema,
  /** 入金作成時刻 (naive ISO date-time) */
  createdAt: z.string(),
})

/** Backpack の `Withdrawal` レスポンススキーマ */
export const withdrawalSchema = z.object({
  /** 出金 ID */
  id: z.number(),
  /** 出金先チェーン */
  blockchain: z.string(),
  /** 出金トランザクションハッシュ */
  transactionHash: z.string().nullish(),
  /** 出金数量 */
  quantity: decimalSchema,
  /** 出金手数料 */
  fee: decimalSchema,
  /** 出金アセットのシンボル */
  symbol: z.string(),
  /** 出金ステータス */
  status: z.string(),
  /** 出金先アドレス */
  toAddress: z.string().nullish(),
  /** 出金作成時刻 (naive ISO date-time) */
  createdAt: z.string(),
  /** Backpack アカウント間の内部送金か */
  isInternal: z.boolean(),
})

export const depositsResponseSchema = z.array(depositSchema)
export const withdrawalsResponseSchema = z.array(withdrawalSchema)

export type Deposit = z.infer<typeof depositSchema>
export type Withdrawal = z.infer<typeof withdrawalSchema>
